import _axios from '@/plugins/axios';
import { BillingsError } from '@/lib/Errors';

export default {
	async getLicenses () {
		const response = await _axios.get('licenses');
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new BillingsError('No summary!');
	},
	async addLicense (body) {
		const response = await _axios.post('licenses', body);
		return response;
		// throw new BillingsError('No summary!');
	},
	async getLicenseForOrganization (body) {
		const response = await _axios.get(`licenses/${body.id}`, body);
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new BillingsError('No summary!');
	},
	async editLicensesForOrganization (body) {
		const response = await _axios.put(`licenses/${body.id}`, body);
		return response;
	},
	async addBulkLicenses (body) {
		const response = await _axios.post('licenses/bulkinsert', body);
		return response;
		// throw new BillingsError('No summary!');
	},
	async deleteLicense (body) {
		const response = await _axios.delete(`licenses/${body.id}`, body);
		return response;
		// throw new BillingsError('No summary!');
	},
	async getLicenseAssignmentsForPatient (patientId) {
		const response = await _axios.get('licenseassignments/getforpatient', { headers: patientId });
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new BillingsError('No summary!');
	},
	async assignLicenseForPatient (body) {
		const response = await _axios.post('licenseassignments/assign', body);
		return response;
		// throw new BillingsError('No summary!');
	},
	async deassignLicenseForPatient (body) {
		const response = await _axios.post('licenseassignments/deassign', body);
		return response;
		// throw new BillingsError('No summary!');
	},
};
